import {useState} from "react";
import { useTranslation } from "react-i18next";

const WhatsAppBox=() => {
    const {t} = useTranslation();
    const [clicked, setClicked] = useState(false);
    return <div className="whatsapp-box p-3 text-center" style={{left: clicked ? 'calc(75.5%)' : 'calc(100%)'}}>
        <i onClick={()=>setClicked((clicked)=>!clicked)} className="bx bxl-whatsapp btn-box"></i>
        <div className="msg">
            <h5 className="mb-2">{t('Support')} 24/7</h5>
            <p className="mb-3">{t('Contact Us on Whatsapp for Live Support')}</p>
        </div>
        <a
            aria-label="whatsapp"
            href="https://api.whatsapp.com/send/?phone=%2B9647508702687&text&type=phone_number&app_absent=0"
            target="_blank"
            className="whatsapp-btn d-inline-block"
        >
            <i className="bx bxl-whatsapp"></i>
        </a>
    </div>
}
export default WhatsAppBox;